import Register from "./components/Register";

import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import Thanks from "./components/Thanks";
import Checkout from "./components/Checkout";


export const config = {
  endpoint: `https://qkart-backend-anirudhharathi.onrender.com/api/v1`,
};

function App() {
  return (
    <div className="App">
      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
      <Switch>
        <Route path="/thanks">
          <Thanks />
        </Route>
        <Route path="/checkout">
          <Checkout />
        </Route>
        
      <Route path="/register">
          <Register />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/">
          <Products />
        </Route>

      </Switch>
    </div>
  );
}

export default App;
